{
	"title": "Avtrykk",
	"backTitle": "Tilbake",
	"company": {
		"name": "HDigital GmbH",
		"address": {
			"street": "Berliner Strasse 6",
			"city": "69120 Heidelberg",
			"country": "Tyskland"
		},
		"contact": {
			"telephone": "Telefon: +49 6221 481-0",
			"telefax": "Telefaks: +49 6221 481-13553",
			"email": "E-post: info@heidelbergmaterials.com"
		},
		"legal": {
			"registeredOffice": "Selskapets forretningskontor: Heidelberg",
			"commercialRegister": "Næringsregister: Mannheim, HRB 741878",
			"managingDirectors": "Administrerende direktører:",
			"directors": {
				"rene": "René Aldach",
				"roland": "Roland Sterr",
				"noman": "Noman Ahmed"
			}
		}
	}
}
